import PublicIcon from "@mui/icons-material/Public";
import FlagIcon from "@mui/icons-material/Flag";
import SatelliteAltIcon from "@mui/icons-material/SatelliteAlt";
export default function Bottom() {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        background: "#096d92ff",
        padding: "0 10%",
        color: "blue",
      }}
    >
      <div  >
        <PublicIcon style={{width:"30%",height:"50%", color:"yellow"}}></PublicIcon>
        <h1 style={{color:"yellow"}}>THE WORLD</h1>
      </div>
      <div  >
        <FlagIcon style={{width:"30%",height:"50%", color:"blueviolet"}}></FlagIcon>
        <h1 style={{color:"blueviolet"}}>FLAG</h1>
      </div>
      <div >
        <SatelliteAltIcon style={{width:"30%",height:"50%", color:"black"}}></SatelliteAltIcon>
        <h1 style={{color:"black"}}>INTERNET</h1>
      </div>
    </div>
  );
}
